import { render, staticRenderFns } from "./DDCelebrate.vue?vue&type=template&id=79168ef2&scoped=true"
import script from "./DDCelebrate.vue?vue&type=script&lang=js"
export * from "./DDCelebrate.vue?vue&type=script&lang=js"
import style0 from "./DDCelebrate.vue?vue&type=style&index=0&id=79168ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79168ef2",
  null
  
)

export default component.exports